<template>
    <div id="intraoralRoot">
        <div id="intraoralViewer" class="intraoral-flex-item">
            <div id="intraoralContainer" class="intraoral-container"> </div>

            <img id="intraoralListBtn" v-if="viewMode.isLoaded" data-toggle="collapse" data-target="#intraoralListPanel"
                aria-expanded="false" title="Settings" src="images/menu_white.png"
                class="intraoral-list-btn intraoral-list-ctrl" />

            <div id="intraoralEditHint1" class="intraoral-hint intraoral-edit-item">Click tooth to select
            </div>
            <div id="intraoralEditHint2" class="intraoral-hint intraoral-hint2 intraoral-edit-item">Double click on
                gingiva
                to
                add new</div>

            <div id="intraoralAddContourHint1" class="intraoral-hint intraoral-add-item">Click gingiva to add tooth
                point
            </div>
            <div id="intraoralAddContourHint2" class="intraoral-hint intraoral-hint2 intraoral-add-item">Click last
                point to
                finish shape</div>

            <div id="intraoralBrushButtons" class="intraoral-brush-item">
                <button class="intraoral-button" v-on:click="completeBrushClick()">
                    COMPLETE
                </button>
                <button class="intraoral-button" v-on:click="cancelBrushClick()">
                    CANCEL
                </button>
            </div>

            <div id="intraoralAddButtons" class="intraoral-add-item">
                <button class="intraoral-button" v-on:click="cancelAddClick()">
                    CANCEL
                </button>
            </div>

            <div class="intraoral-zoom-container" v-show="viewMode.isLoaded">
                <img src="images/white_plus.png" class="intraoral-zoom-btn" v-on:click="changeZoom(1)"
                    title="Increase Zoom" />
                <img src="images/white_minus.png" class="intraoral-zoom-btn" v-on:click="changeZoom(-1)"
                    title="Decrease Zoom" />
                <!-- <img src="images/reset.png" class="dicom-zoom-btn" v-on:click="resetZoom()" title="Reset" /> -->
            </div>

            <img v-if="viewMode.isLoaded && viewMode.isDouble"
                :src="viewMode.isUpper ? 'images/intraoral/INTRAORAL_UPPER_RED.png' : 'images/intraoral/INTRAORAL_UPPER.png'"
                class="jaw-btn upper-jaw-btn" v-on:click="switchUpper()" title="Upper Jaw" />
            <img v-if="viewMode.isLoaded && viewMode.isDouble"
                :src="viewMode.isLower ? 'images/intraoral/INTRAORAL_LOWER_RED.png' : 'images/intraoral/INTRAORAL_LOWER.png'"
                class="jaw-btn lower-jaw-btn" v-on:click="switchLower()" title="Lower Jaw" />
            <img v-if="viewMode.isLoaded && viewMode.isDouble"
                :src="viewMode.isFrontView ? 'images/intraoral/INTRAORAL_FRONT_RED.png' : 'images/intraoral/INTRAORAL_FRONT.png'"
                class="jaw-btn front-jaw-btn" v-on:click="switchFront()" title="Front View" />

            <img v-if="viewMode.isLoaded"
                :src="viewMode.isOriginalView ? 'images/original_red.png' : 'images/original_white.png'"
                class="jaw-btn original-jaw-btn" v-on:click="switchOriginalClick()" title="Original STL" />

            <img v-if="viewMode.isLoaded && viewMode.hasSmoothView && !viewMode.isEdit"
                :src="viewMode.isSmoothView ? 'images/smooth_lines_red.png' : 'images/smooth_lines_white.png'"
                class="jaw-btn smooth-jaw-btn" v-on:click="switchSmoothClick()" title="Smooth" />

            <div v-show="viewMode.isLoaded" id="intraoralColor" class="input-group mb-2 mt-1 input-group-sm">
                <!-- <div class="input-group-prepend">
                <span class="input-group-text">Teeth Color:</span>
            </div> -->
                <select v-model="teethColor" class="form-control form-control-sm intraoral-tool-select"
                    @change="teethColorChanged()">
                    <option v-for="option in teethColors" v-bind:value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>

            <div id="selectedToothHint" class="intraoralHint" v-show="viewMode.isLoaded"></div>
            <div id="casePostprocessingHint" class="intraoralHint"
                v-show="viewMode.isLoaded && (viewMode.isSaving || viewMode.isPostprocessing)">
                <span v-show="viewMode.isSaving"> Case saving...</span>
                <span v-show="!viewMode.isSaving && viewMode.isPostprocessing"> Case postprocessing...</span>
                <img class="intraoral-save-img" src="images/dark-blue-spinner.gif" />
            </div>

            <div v-show="viewMode.isLoaded && !isViewMode" class="intraoral-tools">

                <img v-show="viewMode.isEdit" src="images/undo_white.png" class="intraoral-tool-btn undo-btn"
                    v-on:click="undo()" title="Undo" />
                <img v-show="viewMode.isEdit" src="images/redo_white.png" class="intraoral-tool-btn redo-btn"
                    v-on:click="redo()" title="Redo" />

                <img v-show="viewMode.isEdit" class="intraoral-tool-btn contour-btn" v-on:click="contourModeClick()"
                    title="Contour Tool"
                    :src="!viewMode.isBrushMode ? 'images/bezier_red.png' : 'images/bezier_white.png'" />
                <img v-show="viewMode.isEdit" class="intraoral-tool-btn brush-btn" v-on:click="brushModeClick()"
                    title="Brush Tool"
                    :src="viewMode.isBrushMode ? 'images/brush_red.png' : 'images/brush_white.png'" />

                <img v-if="!viewMode.isFrontView && !viewMode.isOriginalView"
                    :src="viewMode.isEdit ? 'images/annotation_red.png' : 'images/annotation_white.png'"
                    class="intraoral-tool-btn edit-btn" v-on:click="switchEditModeClick()" title="Edit" />

                <!-- <img id="intraoralRepairBtn" src="images/repair_white.png" class="intraoral-tool-btn repair-btn"
                v-on:click="repairColouring()" title="Repair Colouring" /> -->

                <!-- <img id="intraoralSmoothBtn" src="images/border_white.png" class="intraoral-tool-btn border-btn"
                v-on:click="smoothBorder()" title="Smooth Border" />  -->

                <img v-show="!viewMode.isFrontView && !viewMode.isOriginalView" class="intraoral-tool-btn measure-btn"
                    v-on:click="switchMeasureModeClick()" title="Measure"
                    :src="viewMode.isMeasureMode ? 'images/measure_red.png' : 'images/measure_white.png'" />

                <img v-show="!viewMode.isFrontView && !viewMode.isOriginalView" class="intraoral-tool-btn arch-btn"
                    v-on:click="switchArchModeClick()" title="Arch Curve"
                    :src="viewMode.isArchMode ? 'images/arc_curve_red.png' : 'images/arc_curve_white.png'" />

                <img v-show="!viewMode.isFrontView && !viewMode.isOriginalView" class="intraoral-tool-btn num-btn"
                    v-on:click="switchTeethNumbersClick()"
                    :title="viewMode.showTeethNumbers ? 'Hide teeth numbers' : 'Show teeth numbers'"
                    :src="viewMode.showTeethNumbers ? 'images/numbers_red.png' : 'images/numbers_white.png'" />

                <img v-if="viewMode.hasPanoramicRoots"
                    :src="viewMode.isPanoramicRoots ? 'images/teeth_red.png' : 'images/teeth_white.png'"
                    class="intraoral-tool-btn panoramic-roots-btn" v-on:click="switchPanoramicRootsClick()"
                    title="Panoramic Roots" />

                <img :src="viewMode.isFilledTeethView ? 'images/tooth_red.png' : 'images/tooth_white.png'"
                    class="intraoral-tool-btn filled-teeth-btn" v-on:click="switchFilledTeethViewClick()"
                    title="Root Stubs" />

                <img src="images/braces_white.png" class="intraoral-tool-btn braces-btn"
                    v-on:click="removeBracesClick()" title="Remove Braces" />

                <img src="images/save_white.png" class="intraoral-tool-btn save-btn" v-on:click="saveOnServer()"
                    title="Save" />

                <img class="intraoral-tool-btn export-btn" v-if="viewMode.allowDownloads" src="images/export_white.png"
                    v-on:click="showExportDialogClick($event)" title="Export" />

                <img src="images/reset.png" class="intraoral-tool-btn reset-btn" v-on:click="reset()" title="Reset" />
                <img src="images/globalReset1.png" class="intraoral-tool-btn global-reset-btn"
                    v-on:click="globalReset()" title="Global Reset" />

            </div>

            <div v-show="viewMode.isEdit && viewMode.isBrushMode" class="intraoral-brush-tools">
                <img class="intraoral-tool-btn brush-draw-btn" v-on:click="brushDrawClick()" title="Draw"
                    :src="viewMode.isBrushDraw ? 'images/draw_red.png' : 'images/draw_white.png'" />
                <img class="intraoral-tool-btn brush-erase-btn" v-on:click="brushEraseClick" title="Erase"
                    :src="viewMode.isBrushDraw ? 'images/erase_white.png' : 'images/erase_red.png'" />

                <select v-model="viewMode.brushSize" class="form-control form-control-sm brush-tool-select"
                    @change="brushSizeChanged()">
                    <option v-for="option in brushSizes" v-bind:value="option">
                        {{ option }}
                    </option>
                </select>
            </div>

            <div v-show="viewMode.isEdit && viewMode.isBrushMode" class="intraoral-brush-hint">
                Hold Ctrl key to {{ viewMode.isBrushDraw ? 'paint' : 'erase' }}
            </div>

            <img v-if="viewMode.isLoaded && isClosable" src="images/cross_white.png"
                class="intraoral-tool-btn close-btn" v-on:click="close()" title="Exit Intraoral View" />
            <!--  -->
            <div v-show="viewMode.isLoaded" id="intraoralBottomPanel">
                <img title="Occlusal View" src="images/intraoral/INTRAORAL_LOWER.png" class="intraoral-bottom-img"
                    v-on:click="rotateToView($event, 1)" />
                <img title="Occlusal Reversed" src="images/intraoral/INTRAORAL_UPPER.png" class="intraoral-bottom-img"
                    v-on:click="rotateToView($event, 2)" />
                <img title="Front View" src="images/intraoral/INTRAORAL_FRONT.png" class="intraoral-bottom-img"
                    v-on:click="rotateToView($event, 3)" />
                <img title="Rear View" src="images/intraoral/INTRAORAL_REAR.png" class="intraoral-bottom-img"
                    v-on:click="rotateToView($event, 4)" id="intraoralRearBtn" />
                <img title="Left Side" src="images/intraoral/INTRAORAL_RIGHT.png" class="intraoral-bottom-img"
                    v-on:click="rotateToView($event, 5)" />
                <img title="Right Side" src="images/intraoral/INTRAORAL_LEFT.png" class="intraoral-bottom-img"
                    v-on:click="rotateToView($event, 6)" />
                <img title="Center View" src="images/center_white.png" class="intraoral-bottom-img"
                    v-on:click="setRotateCenterClick()" />
            </div>

            <!-- <img id="intraoralRotateImg" class="intraoral-tool-btn" title="Rotate" src="images/angle_icon.png"
            v-on:click="toggleRotatePanel($event)" /> -->

            <div id="intraoralOpacitySlider" v-show="viewMode.isLoaded" class="intraoral-slider-container-sm">
                <span class="intraoral-span-sm intraoral-opacity-span">OPACITY</span>
                <span class="intraoral-span-sm">1</span>
                <div ref="opacitySlider" class="intraoral-slider-sm"></div>
                <span class="intraoral-span-sm">0</span>
            </div>

            <div v-show="viewMode.isPanoramicRoots" id="ioPanoramicShowDiv" class="toggle-div"
                v-on:click.stop="setShowPanoramicImg($event)">
                <input id="ioPanoramicShowButton" type="checkbox" />
                <div id="ioPanoramicShowTitle" class="toggle-title">Show Panoramic Image</div>
            </div>

        </div>
        <IntraoralPanoramic :viewMode="viewMode" />
    </div>
</template>

<script>

import {
    updateOpacity, switchViewModes, saveIntraoralData, resetIntraoral,
    globalResetIntraoral, switchEditMode, cancelAdd, setRotateCenter,
    rotateIntraoralToView, randomColorValue, monochromeColorValue,
    greyColorValue, changeTeethColor, intraoralUndo, intraoralRedo,
    smoothSelectedToothBorder, repairIntraoralColouring,
    switchTeethNumbers, switchFilledTeethView, switchPanoramicRoots, ioViewer,
    switchToContourMode, switchToBrushMode, switchBrushDrawMode, updateBrushMesh,
    completeBrush, cancelBrush, removeBraces, resetIoView, switchShowPanoramicImg,
    viewMode, switchOriginalView, switchSmoothView
} from "./IntraoralManager";
import IntraoralPanoramic from "./IntraoralPanoramic.vue";
import {
    processIntraoralZip
} from "./IntraoralLoader";

import {
    switchMeasureMode
} from "./measure/IntraoralMeasureMode";
import {
    switchArchMode
} from "./measure/IntraoralArchMode";

import { showExportDialog } from "@/components/reports/ReportsManager";

export default {
    name: "IntraoralViewer",
    data() {
        return {
            isClosable: true,
            isViewMode: false,
            teethColor: 'random',
            teethColors: [
                { text: "Random Color", value: randomColorValue },
                { text: "Grey Color", value: greyColorValue, }, // 808080
                { text: "White Color", value: '#FFFFFF' },
                { text: "Monochrome", value: monochromeColorValue }
            ],
            brushSizes: [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10
            ],
        };
    },
    props: {
        viewMode: {
            type: Object,
            required: true
        },
    },
    components: {
        IntraoralPanoramic,
    },
    mounted() {
        if (vueApp.isDemo) {
            // let demoUrl = "demo/demo.zip";
            // this.fetchZip(demoUrl, (zip) => {
            //     processDemoZip(zip);
            //     this.viewMode.isLoaded = true;
            //     $(".intraoral-list-ctrl").css("display", "block");
            // });
            return;
        }

        if (vueApp.isViewMode) {
            this.viewMode.isEdit = false;
            this.isViewMode = true;
        }
        this.isClosable = !!vueApp.zipFile;
        processIntraoralZip(this.viewMode);
        this.initControls();
    },
    methods: {
        setShowPanoramicImg: function (event) {
            this.viewMode.showPanoramicImg = !this.viewMode.showPanoramicImg;
            console.log("setShowPanoramicImg", event.currentTarget.id, this.viewMode.showPanoramicImg);
            if (event) {
                switchToggle(event.currentTarget.id, this.viewMode.showPanoramicImg);
            }
            switchShowPanoramicImg(this.viewMode.showPanoramicImg);
        },
        initControls: function () {
            canecode_switch("#ioPanoramicShowButton");
            switchToggle("ioPanoramicShowDiv", this.viewMode.showPanoramicImg);

            // this.sliderId = `${this.app.divId}_slider`;
            // $(`#${this.sliderId}`).slider("value", this.current);
            // this.$refs.opacitySlider.setAttribute("id", this.sliderId);
            $(`.intraoral-slider-sm`).slider({
                orientation: "vertical",
                min: 0,
                max: 1,
                step: 0.01,
                value: 1,
                slide: (slideEvent, ui) => {
                    updateOpacity(ui.value);
                    // console.log(slideEvent, ui);
                }
            });
        },
        changeZoom: function (factor) {
            ioViewer.controls.changeZoom(factor);
        },
        undo: function () {
            intraoralUndo();
        },
        redo: function () {
            intraoralRedo();
        },
        smoothBorder: function () {
            smoothSelectedToothBorder();
        },
        repairColouring: function () {
            repairIntraoralColouring();
        },
        saveOnServer: function () {
            $("#intraoralSaveDialog").modal();

            return;

            let updateExportedData = false;
            swal({
                text: "Are you sure you want to save intraoral changes?",
                buttons: {
                    yes: { text: "Yes", value: true },
                    no: { text: "No", value: false }
                }
            }).then(save => {
                if (save) {
                    saveIntraoralData(updateExportedData);
                }
            });

            var $swalCheckbox = $(
                `<div class='swal-checkbox-div' style='margin-left: 50px;'>
					<input class='swal-checkbox-cb' type='checkbox' id='swalCheckbox'/> 
					<label class='swal-checkbox-lb' for='swalCheckbox'>Update exported data</label>
				</div>`
            );
            // style='color: rgba(0, 0, 0, .64);
            $(".swal-footer").append($swalCheckbox);
            $("#swalCheckbox").change(() => {
                updateExportedData = $("#swalCheckbox").is(":checked");
            });
        },
        switchUpper: async function () {
            if (!this.viewMode.isUpper) {
                this.viewMode.isUpper = true;
                this.viewMode.isLower = this.viewMode.isFrontView = false;
                await switchViewModes(this.viewMode.isUpper, this.viewMode.isLower);
                if (this.viewMode.isEdit) {
                    await switchEditMode(false);
                    await switchEditMode(true);
                }
            }
        },
        switchLower: async function () {
            if (!this.viewMode.isLower) {
                this.viewMode.isLower = true;
                this.viewMode.isUpper = this.viewMode.isFrontView = false;
                await switchViewModes(this.viewMode.isUpper, this.viewMode.isLower);
                if (this.viewMode.isEdit) {
                    await switchEditMode(false);
                    await switchEditMode(true);
                }
            }
        },
        switchFront: async function () {
            if (!this.viewMode.isFrontView) {
             
                this.viewMode.isFrontView = true;
                this.viewMode.isUpper = this.viewMode.isLower = this.viewMode.isEdit = false;
                await switchViewModes(true, true);
            }
        },
        switchOriginalClick: async function () {
            let tempValue = !this.viewMode.isOriginalView;
            await resetIoView();
            switchOriginalView(tempValue);
        },
        switchSmoothClick: async function () {
            let tempValue = !this.viewMode.isSmoothView;
            // await resetIoView();
            switchSmoothView(tempValue);
        },
        switchMeasureModeClick: async function () {
            let newValue = !this.viewMode.isMeasureMode;
            if (newValue) {
                await resetIoView();
            }
            switchMeasureMode(newValue);
        },
        switchArchModeClick: async function () {
            let newValue = !this.viewMode.isArchMode;
            if (newValue) {
                await resetIoView();
            }
            switchArchMode(newValue);
        },
        switchTeethNumbersClick: async function () {
            let newValue = !this.viewMode.showTeethNumbers;
            if (newValue) {
                await resetIoView();
            }
            switchTeethNumbers(newValue);
        },
        switchEditModeClick: async function () {
            let newValue = !this.viewMode.isEdit;
            // if (this.viewMode.isEdit) {
            await resetIoView(true);
            // }
            switchEditMode(newValue);
        },
        switchPanoramicRootsClick: async function () {
            let newValue = !this.viewMode.isPanoramicRoots;
            if (newValue) {
                await resetIoView();
            }
            switchPanoramicRoots(newValue);
        },
        switchFilledTeethViewClick: async function () {
            let newValue = !this.viewMode.isFilledTeethView;
            if (newValue) {
                await resetIoView();
            }
            switchFilledTeethView(newValue);
        },
        removeBracesClick: async function () {
            removeBraces();
        },
        reset: function () {
            swal({
                text: "Are you sure you want to reset to saved state?",
                buttons: {
                    yes: { text: "Yes", value: true },
                    no: { text: "No", value: false }
                }
            }).then(confirm => {
                if (confirm) {
                    resetIntraoral();
                }
            });
        },
        globalReset: function () {
            swal({
                text: "Are you sure you want to reset all changes?",
                buttons: {
                    yes: { text: "Yes", value: true },
                    no: { text: "No", value: false }
                }
            }).then(confirm => {
                if (confirm) {
                    globalResetIntraoral();
                }
            });
        },
        toggleRotatePanel: function (event) {
            let isVisible = $("#intraoralBottomPanel").css("display") != "none";
            if (isVisible) {
                $("#intraoralBottomPanel").fadeOut();
            } else {
                // vueApp.leaveModes(false);
                $("#intraoralBottomPanel").slideDown();
            }
        },
        rotateToView: function (event, viewNumber) {
            rotateIntraoralToView(viewNumber, true);
        },
        teethColorChanged: function () {
            changeTeethColor(this.teethColor);
        },
        close: function () {
            vueApp.isIntraoralView = false;
            document.querySelector('#intraoralRoot').style.display = 'none';
            $(".menu3d").removeAttr("style")
            // $(".menu3d").attr("disabled", false);
            document.querySelector('#views_cont').style.display = 'flex';
            if (viewer) viewer.do_resize();
        },
        cancelAddClick: function () {
            cancelAdd();
            switchEditMode(this.viewMode.isEdit);
        },
        completeBrushClick: function () {
            completeBrush(false, true);
        },
        cancelBrushClick: function () {
            cancelBrush();
        },
        setRotateCenterClick: function () {
            setRotateCenter();
        },
        showExportDialogClick: function (event) {
            showExportDialog();
        },
        contourModeClick: function () {
            switchToContourMode();
        },
        brushModeClick: function () {
            switchToBrushMode();
        },
        brushDrawClick: function () {
            switchBrushDrawMode(true);
        },
        brushEraseClick: function () {
            switchBrushDrawMode(false);
        },
        brushSizeChanged: function () {
            console.log("brushSizeChanged", this.viewMode.brushSize);
            updateBrushMesh();
        },
    }
};
</script>

<style scoped>
.intraoral-list-btn {
    cursor: pointer;
    position: absolute;
    top: 50px;
    left: 14px;
    width: 30px;
    height: 30px;
    z-index: 9;
}

.intraoralHint {
    position: absolute;
    top: 20px;
    background-color: transparent;
    color: white;
    /* font-weight: bold; */
    text-align: center;
}

#selectedToothHint {
    /* top: 15px; */
    font-weight: 500;
    width: 120px;
    left: calc(50% - 85px);
    /* border: 1px solid #FFFFFF; */
}

#casePostprocessingHint {
    width: 250px;
    top: 57px;
    right: 53px;
}

.intraoral-save-img {
    display: inline;
    width: 29px;
    height: 29px;
}

#intraoralColor {
    position: absolute;
    width: 130px;
    top: 11px;
    left: 12px;
    z-index: 9;
    /* right: 160px; */
}

.intraoral-tool-select {
    height: 27px;
    padding: 2px;
}

#intraoralRotateImg {
    width: 30px;
    height: 30px;
    bottom: 15px;
    left: calc(50% - 5px);
}

#intraoralBottomPanel {
    position: absolute;
    bottom: 20px;
    left: calc(50% - 125px);
}

.intraoral-bottom-img {
    width: 35px;
    height: 35px;
    margin-left: 8px;
    text-align: right;
    cursor: pointer;
    border: 1px solid #FFFFFF;
}

#intraoralRearBtn {
    padding: 5px;
}

#intraoralRoot {
    position: relative;
    width: 100%;
    height: calc(100% - 35px);
    /* margin: 0 auto; */
    /* gap: 0; */
    /* flex-direction: row; */

    -ms-box-orient: horizontal;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -moz-flex;
    display: -webkit-flex;
    display: flex;

    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-flex-flow: row wrap;
    flex-flow: row wrap;
    -webkit-align-items: stretch;
    align-items: stretch;
    background: #082F5E;
}

/*     width: 100%;*/
/* z-index: 9; */
/* display: block; */
/* box-sizing: border-box; */

#intraoralViewer {
    background: #082F5E;
}


.toggle-div {
    bottom: 70px;
    position: absolute;
    text-align: center;
    z-index: 9;
    color: #ffffff;
    width: auto;
}

.toggle-title {
    font-size: medium;
    font-weight: normal;
    width: 250px;
}

#ioPanoramicShowDiv {
    left: calc(50% - 20px);
}

#ioPanoramicShowTitle {
    margin-left: -80px;
}

.intraoral-flex-item {
    height: 100%;
    text-align: center;
    position: relative;
    flex-grow: 1;
}

.intraoral-container {
    /* background: #77a7fd; */
    position: absolute;
    /* background: #082F5E; */
    width: 100%;
    height: 100%;
    visibility: hidden;
}

.intraoral-hint {
    position: absolute;
    z-index: 999;
    width: 350px;
    left: calc(50% - 195px);
    top: 45px;
    text-align: center;
    color: white;
    font-family: Montserrat, sans-serif;
    background-color: transparent;
    display: none;
}

.intraoral-hint2 {
    top: 70px;
}

#intraoralAddButtons {
    position: absolute;
    text-align: center;
    white-space: nowrap;
    left: calc(50% - 125px);
    top: 105px;
    z-index: 9;
    display: none;
    width: 200px;
    height: 35px;
}

#intraoralBrushButtons {
    position: absolute;
    text-align: center;
    white-space: nowrap;
    left: calc(50% - 112px);
    top: 50px;
    z-index: 9;
    display: none;
    width: 200px;
    height: 35px;
    gap: 10px;
    /* display: flex; */
    /* flex-direction: row-reverse; */
    flex-wrap: nowrap;
}

.intraoral-button {
    display: inline-block;
    /* margin-right: 10px; */
    min-width: 90px;
    width: auto;
    height: 35px;
    border: 0;
    cursor: pointer;
    font-size: small;
    background-color: #4687fc;
    text-align: center;
    color: #ffffff;
}

.intraoral-tools {
    position: absolute;
    top: 15px;
    right: 50px;
    display: flex;
    align-items: stretch;
    gap: 10px;
    z-index: 99;
    /* padding: 0 0.25rem; */
}

.intraoral-brush-tools {
    position: absolute;
    top: 50px;
    right: 260px;
    display: flex;
    align-items: stretch;
    gap: 10px;
    z-index: 99;
    border: 1px solid #FFFFFF;
    border-radius: 3px;
    /* padding: 4px 5px 0 2px; */
    padding: 4px;
}

.intraoral-brush-hint {
    position: absolute;
    top: 90px;
    right: 237px;
    z-index: 99;
    color: white;
}

.brush-tool-select {
    height: 25px;
    padding: 2px;
    margin-left: 2px;
}

.intraoral-tool-btn {
    cursor: pointer;
    /* position: absolute; */
    /* right: 45px; */
    width: 25px;
    height: 25px;
}

.edit-btn {
    margin-right: -4px;
}

.export-btn {
    /* height: 26px; */
    width: 27px;
    margin-top: 1px;
    /* margin-left: 15px; */
}

.filled-teeth-btn {
    margin-top: 1px;
    margin-left: -1px;
}

.panoramic-roots-btn {
    margin-top: -3px;
    margin-right: -3px;
    width: 35px;
    height: 33px;
}

.braces-btn {
    margin-top: -4px;
    margin-left: 0px;
    width: 35px;
    height: 35px;
}

.num-btn {
    width: 46px;
    height: 46px;
    margin-top: -10px;
    margin-right: -5px;
}

.measure-btn {
    width: 23px;
    height: 23px;
    margin-top: 2px;
    margin-left: 3px;
    margin-right: -5px;
}

.arch-btn {
    width: 26px;
    height: 30px;
    margin-top: -2px;
    margin-left: 4px;
    margin-right: -6px;
}

.undo-btn {
    width: 27px;
    height: 27px;
    border: 1px solid #FFFFFF;
}

.redo-btn {
    width: 27px;
    height: 27px;
    border: 1px solid #FFFFFF;
    margin-right: 7px
}

.border-btn {
    width: 27px;
    height: 27px;
}

.save-btn {
    width: 25px;
    height: 25px;
    margin-top: 1px;
}

.reset-btn {
    width: 26px;
    height: 26px;
    margin-left: 3px;
    margin-top: 1px;
}

.global-reset-btn {
    margin-left: -3px;
    margin-top: 2px;
    width: 24px;
    height: 24px;
}

.close-btn {
    position: absolute;
    cursor: pointer;
    top: 17px;
    right: 15px;
    width: 24px;
    height: 24px;
}

.intraoral-zoom-container {
    position: absolute;
    text-align: center;
    left: 155px;
    top: 15px;
    z-index: 99;
}

.intraoral-zoom-btn {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    /* margin-bottom: 12px; */
    color: white;
    cursor: pointer;
    /* font-size: 2rem; */
}

.jaw-btn {
    cursor: pointer;
    position: absolute;
    width: 30px;
    height: 30px;
    z-index: 99;
    border: 1px solid #FFFFFF;
}

.upper-jaw-btn {
    top: 14px;
    left: 215px;
}

.lower-jaw-btn {
    top: 14px;
    left: 250px;
}

.front-jaw-btn {
    top: 14px;
    left: 285px;
}

.original-jaw-btn {
    width: 28px;
    height: 28px;
    top: 15px;
    left: 325px;
    border: 0;
}

.smooth-jaw-btn {
    width: 28px;
    height: 28px;
    top: 15px;
    left: 362px;
    border: 0;
}
</style>

<style>
.intraoral-slider-container-sm {
    position: absolute;
    text-align: center;
    width: 35px;
    right: 20px;
    top: 62px;
    height: calc(100% - 180px);
    z-index: 3;
}

.intraoral-span-sm {
    color: #FFFFFF;
    display: block;
    font-size: small;
}

.intraoral-opacity-span {
    margin-left: -12px;
}

.intraoral-slider-sm {
    height: calc(100% - 7px);
    border-radius: 0;
    outline: none;
    width: 0.38rem;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: calc(50% - 0.25rem);
}

.intraoral-slider-sm .ui-slider-range {
    display: none;
}

.intraoral-slider-sm .ui-slider-handle {
    outline: none;
    border-radius: 30px;
    width: 1.4rem;
    height: 1.4rem;
    left: -.54rem;
}
</style>